<template>
  <div class="b-t-t"
       :class="{'is-v-scroll': isVirtualScroll, 'active': isActive}"
       :style="{'bottom': bottom, 'top': top, 'right': right, 'left':left}"
       @click="$emit('scrollTo')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    offset: {
      type: [String, Number],
      default: 0
    },
    bottom: {
      type: String,
      default: 'none'
    },
    right: {
      type: String,
      default: 'none'
    },
    left: {
      type: String,
      default: 'none'
    },
    top: {
      type: String,
      default: 'none'
    },
    isVirtualScroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive () {
      return this.$store.state.scrollY > Number.parseInt(this.offset)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
div.b-t-t::v-deep {
  opacity: 0;
  visibility: hidden;
  transition: opacity .1s ease;
  position: fixed;

  &.active {
    visibility: visible;
    opacity: 1;
  }

  //&.is-v-scroll {
  //  position: sticky;
  //}
}
</style>
